

































































import ConfirmModal from '@/components/ConfirmModal.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    ConfirmModal,
  },
})
export default class Navbar extends Vue {
  public isActive = false;
  public modalVisible: boolean = false;

  public get groupId() {
    return this.$store.getters.user && this.$store.getters.user.groupId;
  }

  public get userRole() {
    return this.$store.getters.user && this.$store.getters.user.role;
  }

  public logout() {
    this.modalVisible = false;
    this.$store.dispatch('auth/deleteAuthToken');
    this.$router.push('/');
  }

  public redirect(destination: string) {
    if (this.$store.getters['auth/authenticated']) {
      this.$router.push('/' + destination);
    } else {
      this.$router.push('/');
    }
  }

  public toggle() {
    this.isActive = !this.isActive;
  }

  @Watch('$route')
  public onRouteChange() {
    this.isActive = false;
  }
}
